(function () {
  'use strict';
  if (window.greyRidgePACForm) return;

  function pacUpsellUrl(button) {
    var item = button.closest('.kaching-product-upsell-item');
    if (!item) return null;
    var title = item.querySelector('.kaching-product-upsell-item__title');
    var catalogNode = document.getElementById('pac-cart-products');
    var catalog = catalogNode ? JSON.parse(catalogNode.textContent) : [];
    var product = catalog.find(function (entry) { return String(entry.id) === item.dataset.productId; });
    if (!product && !(title && /\((?:pac|82 RCACS|Neepawa Cadets)\)/i.test(title.textContent))) return null;
    var url = new URL(product ? product.url : title.getAttribute('href'), window.location.origin);
    if (item.dataset.variantId) url.searchParams.set('variant', item.dataset.variantId);
    var previewId = new URLSearchParams(window.location.search).get('preview_theme_id');
    if (previewId) url.searchParams.set('preview_theme_id', previewId);
    return url.href;
  }

  function setFieldError(field, show) {
    var error = document.getElementById(field.getAttribute('aria-describedby'));
    field.setAttribute('aria-invalid', show ? 'true' : 'false');
    if (error) {
      error.textContent = show ? field.getAttribute('data-pac-message') : '';
      error.hidden = !show;
    }
  }

  function isComplete(field) {
    return field.type === 'checkbox' ? field.checked : Boolean(field.value.trim());
  }

  function validate(form, focus) {
    var details = form && form.querySelector('[data-pac-details]');
    if (!details) return true;
    var firstInvalid = null;
    details.querySelectorAll('[data-pac-field]').forEach(function (field) {
      var invalid = !isComplete(field);
      setFieldError(field, invalid);
      if (invalid && !firstInvalid) firstInvalid = field;
      if (!invalid && field.type !== 'checkbox') field.value = field.value.trim();
    });
    details.querySelector('[data-pac-summary]').hidden = !firstInvalid;
    if (firstInvalid && focus) {
      firstInvalid.focus({ preventScroll: true });
      firstInvalid.scrollIntoView({ block: 'center', behavior: 'smooth' });
    }
    return !firstInvalid;
  }

  async function submitPAC(event, form) {
    if (!form.querySelector('[data-pac-details]')) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    if (form.dataset.pacSubmitting === 'true' || !validate(form, true)) return;
    var button = form.querySelector('[name="add"]');
    if (!button || button.disabled) return;
    var summary = form.querySelector('[data-pac-summary]');
    var notification = document.querySelector('cart-notification');
    var data = new FormData(form);
    // Read the selected variant directly; theme/app initialization can leave it disabled.
    var variant = form.querySelector('[name="id"]');
    if (variant) data.set('id', variant.value);
    if (notification && notification.getSectionsToRender) {
      data.set('sections', notification.getSectionsToRender().map(function (section) { return section.id; }).join(','));
      data.set('sections_url', window.location.pathname);
      notification.setActiveElement(document.activeElement);
    }
    form.dataset.pacSubmitting = 'true';
    button.disabled = true;
    button.classList.add('loading');
    button.setAttribute('aria-busy', 'true');
    var controller = new AbortController();
    var timeout = setTimeout(function () { controller.abort(); }, 20000);
    try {
      var response = await fetch((window.Shopify.routes.root || '/') + 'cart/add.js', {
        method: 'POST', headers: { 'X-Requested-With': 'XMLHttpRequest', Accept: 'application/json' }, body: data, signal: controller.signal
      });
      var result = await response.json();
      if (!response.ok || result.status) throw new Error(typeof result.description === 'string' ? result.description : 'This item could not be added. Please try again.');
      // The cart app observes cart/add requests and opens its own drawer.
      if (!window.kachingCartApi || !window.kachingCartApi.openCart) {
        if (notification && notification.renderContents) notification.renderContents(result);
        else window.location.assign((window.Shopify.routes.root || '/') + 'cart');
      }
    } catch (error) {
      summary.textContent = error.name === 'AbortError' || error instanceof TypeError
        ? 'We could not confirm the cart update. Check your cart before trying again.'
        : error.message || 'This item could not be added. Please try again.';
      summary.hidden = false;
    } finally {
      clearTimeout(timeout);
      form.dataset.pacSubmitting = 'false';
      button.disabled = false;
      button.classList.remove('loading');
      button.removeAttribute('aria-busy');
      button.removeAttribute('aria-disabled');
    }
  }

  window.addEventListener('click', function (event) {
    if (!(event.target instanceof Element)) return;
    var upsellButton = event.target.closest('.kaching-product-upsell-item__add-to-cart');
    var upsellUrl = upsellButton && pacUpsellUrl(upsellButton);
    if (upsellUrl) {
      event.preventDefault();
      event.stopImmediatePropagation();
      window.location.assign(upsellUrl);
      return;
    }
    var button = event.target.closest('button[name="add"], button[type="submit"], input[type="submit"]');
    if (button && button.form) submitPAC(event, button.form);
  }, true);

  window.addEventListener('submit', function (event) {
    if (event.target instanceof HTMLFormElement) submitPAC(event, event.target);
  }, true);

  document.addEventListener('input', function (event) {
    var field = event.target;
    if (!field.matches || !field.matches('[data-pac-field]')) return;
    if (field.getAttribute('aria-invalid') === 'true') setFieldError(field, !isComplete(field));
    var details = field.closest('[data-pac-details]');
    if (!details.querySelector('[aria-invalid="true"]')) details.querySelector('[data-pac-summary]').hidden = true;
  });

  document.addEventListener('change', function (event) {
    var field = event.target;
    if (field.matches && field.matches('[data-pac-field][type="checkbox"]')) {
      setFieldError(field, !field.checked);
      var details = field.closest('[data-pac-details]');
      if (!details.querySelector('[aria-invalid="true"]')) details.querySelector('[data-pac-summary]').hidden = true;
    }
  });

  function labelUpsells(root) {
    if (!root.querySelectorAll) return;
    root.querySelectorAll('.kaching-product-upsell-item__add-to-cart').forEach(function (button) {
      if (pacUpsellUrl(button) && button.textContent !== 'Order details') button.textContent = 'Order details';
    });
  }
  function formatCartItems(root) {
    if (!root.querySelectorAll) return;
    var closestItem = root.closest && root.closest('.kaching-cart-item');
    var items = closestItem ? [closestItem] : root.querySelectorAll('.kaching-cart-item');
    var catalogNode = document.getElementById('pac-cart-products');
    var catalog = catalogNode ? JSON.parse(catalogNode.textContent) : [];
    items.forEach(function (item) {
      var title = item.querySelector('.kaching-cart-item__title');
      var isPAC = catalog.some(function (entry) { return String(entry.id) === item.dataset.productId; }) || Boolean(title && /\((?:pac|82 RCACS|Neepawa Cadets)\)/i.test(title.textContent));
      item.classList.toggle('pac-cart-item', isPAC);
      var details = [];
      item.querySelectorAll('.kaching-cart-item__property-option').forEach(function (row) {
        var label = row.querySelector('.kaching-cart-item__property-label');
        var key = label ? label.textContent.replace(/:\s*$/, '').trim() : '';
        var isDetail = isPAC && ['Student Name', 'Grade', 'Teacher', 'School pickup', 'Pickup acknowledgement', 'Fundraiser', 'Order name', 'Cadet name', 'Fulfillment'].indexOf(key) !== -1;
        row.classList.toggle('pac-cart-property', isDetail);
        row.classList.toggle('pac-cart-property--pickup', isDetail && (key === 'School pickup' || key === 'Pickup acknowledgement' || key === 'Fulfillment'));
        row.classList.toggle('pac-cart-property--private', isPAC && (key === '_Pickup acknowledgement' || key === '_Fulfillment acknowledgement'));
        row.classList.remove('pac-cart-property--first', 'pac-cart-property--last');
        if (isDetail) details.push(row);
      });
      if (details.length) {
        details[0].classList.add('pac-cart-property--first');
        details[details.length - 1].classList.add('pac-cart-property--last');
      }
    });
  }
  labelUpsells(document);
  formatCartItems(document);
  new MutationObserver(function (records) {
    records.forEach(function (record) {
      record.addedNodes.forEach(function (node) {
        if (node.nodeType !== 1) return;
        labelUpsells(node.closest('.kaching-product-upsell-item') || node);
        formatCartItems(node);
      });
    });
  }).observe(document.documentElement, { childList: true, subtree: true });

  window.greyRidgePACForm = { validate: validate };
})();
